module.exports = __webpack_public_path__ + "img/peace.c85f9aa4.svg";